export const SET_RESERVATION_ID = 'SET_RESERVATION_ID';
export const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID';
export const SET_RESERVATION_INFO_BY_ID = 'SET_RESERVATION_INFO_BY_ID';
export const RESET_EDIT_RESERVATION = 'RESET_EDIT_RESERVATION';